import {GridWidgetDataField} from './grid-widget-data-field';
import {GridWidgetFilter} from './grid-widget-filter';

export class FilterContainer {

  filter: GridWidgetFilter;

  //The selected datafield for this filter chosen by the user from the drop down.
  dataField: GridWidgetDataField;

  //As dataField changes, this needs to update too
  //but only after the listener gets it.
  lastDataField: GridWidgetDataField;

  //This is how the select box can know which field is selected.
  get selectedFieldId(): string {
    return this.dataField.id;
  }

  //This is how the select box can know which field is selected.
  //This is also how you set the filter manually.
  set selectedFieldId(value: string) {
    this.dataField = this.availableFilterFields[value];

    let newFilter: GridWidgetFilter = this.dataField.getFilterInstance();
    newFilter.useDataFromExistingFilter(this.filter);
    this.filter = newFilter;
    //this.providerTokenChange.emit('token-change');
  }

  /**
   * These are the fields that show up in the select box for which
   * field to filter on.
   * A subset of FilterTask.filterFields.
   * The number of values in this object change as the user interacts with the filter.
   * NOTE: gridWidget.html actually loops over an array of all the fields in order, and uses
   * this map to determine whether to show the field in the list or not.
   * Map<fieldKey, GridWidgetFilter>
   */
  availableFilterFields: {[fieldId: string]: GridWidgetDataField} = {};

  constructor(availableFilterFields: {[key: string]: GridWidgetDataField}, defaultFieldId?: string) {
    this.availableFilterFields = availableFilterFields;

    //If there is no default key,
    //or the key is not available then assign it.
    if (defaultFieldId == null || availableFilterFields[defaultFieldId] == null) {
      defaultFieldId = Object.keys(this.availableFilterFields)[0];
    }

    this.dataField = availableFilterFields[defaultFieldId];
    this.filter = this.dataField.getFilterInstance();
    //this.selectedFieldId = this.dataField.id;
    this.lastDataField = this.dataField;
  }

  /**
   * Called when created and should be called when
   * the dataField is changed.
   *
   * Updates this.lastDataField to the current one, and returns the previous this.lastDataField.
   */
  update(): GridWidgetDataField {
    let lastDataField = this.lastDataField;
    this.lastDataField = this.dataField;

    return lastDataField;
  }

  /**
   * Determines if the dataRow passes the "this" filter object.
   * @param dataRow - A javascrcript object that represents a row in the table
   * being wrapped by the grid widget.
   * @returns boolean - true if the value in dataRow passes the filter
   *                    false if the value in dataRow does not pass the filter
   */
  passesFilter(dataRow): boolean {
    return this.filter.passesFilter(dataRow);
  }

  /**
   * This is what the PaginationHelper instances will call to get data for
   * the refresh function to turn the result of it into a REST call.
   *
   * @returns a Javascript Objects in the form:
   * {
   *   field: The field key
   *   comparator: string, = < <= >= or >
   *   value: The value the user typed or selected, converted to the correct type.
   * }
   */
  // getCondensed() {
  //     return {
  //         field: this.dataField.fieldKey,
  //         comparator: this.comparator,
  //         value: this.getValue(),
  //         units: this.selectedUnits
  //     };
  // };

  toString(): string {
    return this.dataField.id;
  }
}
